"use client"

import { motion } from "framer-motion"
import { FaUser, FaEnvelope, FaPhone, FaArrowLeft } from "react-icons/fa"

const inputVariants = {
  focus: { scale: 1.02, transition: { duration: 0.2 } },
}

const BasicLawFirmForm = ({ formData, handleChange, handleNextStep, handlePrevStep }) => {
  // Función para manejar cambios en los campos del bufete
  const handleOrgChange = (e) => {
    const { name, value } = e.target
    handleChange({
      target: {
        name: `org.${name}`,
        value,
      },
    })
  }

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-white rounded-xl shadow-xl overflow-hidden"
    >
      <div className="bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] py-4 px-6">
        <h3 className="text-white text-xl font-semibold">Información Básica del Bufete</h3>
        <p className="text-blue-100 text-sm">Paso 2 de 3</p>
      </div>

      <form id="lawFirmForm" onSubmit={handleNextStep} className="p-6 space-y-4">
        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="name" className="block mb-1 text-sm font-medium text-gray-700">
            Nombre del Bufete
          </label>
          <div className="relative">
            <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleOrgChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="Ingrese el nombre de su bufete"
            />
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="email" className="block mb-1 text-sm font-medium text-gray-700">
            Correo Electrónico del Bufete
          </label>
          <div className="relative">
            <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleOrgChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="bufete@ejemplo.com"
            />
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="phone" className="block mb-1 text-sm font-medium text-gray-700">
            Teléfono del Bufete
          </label>
          <div className="relative">
            <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleOrgChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="+34 XXX XXX XXX"
            />
          </div>
        </motion.div>

        <div className="flex gap-4 pt-4">
          <motion.button
            type="button"
            onClick={handlePrevStep}
            className="w-1/3 bg-gray-200 text-gray-800 py-3 px-4 rounded-lg hover:bg-gray-300 transition duration-300 font-medium flex items-center justify-center"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FaArrowLeft className="mr-2" />
            Volver
          </motion.button>

          <motion.button
            type="submit"
            className="w-2/3 bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-indigo-800 transition duration-300 font-medium"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Continuar
          </motion.button>
        </div>
      </form>
    </motion.div>
  )
}

export default BasicLawFirmForm

